import { useContext, useEffect, useState } from "react";

import { CubeIcon } from "@heroicons/react/24/outline";
import { Skeleton } from "@upstageai/ui";

import {
  ValidatorFileContext,
  ValidatorModelsContext,
} from "../../hooks/useFile";
import { getModelName, getModelStatus } from "../../utils/file";
import { endpointStore } from "../../utils/mobx/EndpointStore";
import { Capitalize } from "../../utils/stringUtil";
import { cn } from "../../utils/style";

const ModelNameSkeleton = () => {
  return (
    <div className="flex flex-1">
      <Skeleton className="h-4 w-32" />
    </div>
  );
};

export default function ModelInfo() {
  // TODO : extractor에서 NO_MODEL != "true"일 때 테스트 필요

  const { files, selectedFileIndex, inferenceState } =
    useContext(ValidatorFileContext);
  const { models } = useContext(ValidatorModelsContext);
  const { endpointType } = endpointStore;

  const [modelName, setModelName] = useState<string>("");
  const [modelStatus, setModelStatus] = useState<string>("");

  useEffect(() => {
    const name = getModelName(files, selectedFileIndex);
    const status = getModelStatus(
      files,
      selectedFileIndex,
      models,
      endpointType,
    );

    if (name) setModelName(name);
    if (status) setModelStatus(status);
  }, [files, selectedFileIndex, endpointType]);

  if (!modelName) return null;

  const ModelName = () => {
    return (
      <div className="flex w-full items-center justify-start">
        <span className="subtle text-muted-darker">
          {modelName}
          {modelStatus !== "public" && (
            <span
              className={cn({
                "detail ml-2 capitalize": true,
                "text-accent-blue-foreground": modelStatus === "beta",
                "text-accent-green": modelStatus !== "beta",
              })}
            >
              {Capitalize(modelStatus)}
            </span>
          )}
        </span>
      </div>
    );
  };

  return (
    <div className="flex w-full items-center justify-center gap-4">
      <div className="flex gap-1.5 self-start py-2">
        <CubeIcon className="size-5 text-muted-dark" />
        <span className="subtle-medium">Model</span>
      </div>
      {inferenceState.isInfering ? (
        <ModelNameSkeleton />
      ) : (
        <div className="flex flex-1 items-center justify-center rounded-lg border-border-medium bg-surface px-3 py-2">
          <ModelName />
        </div>
      )}
    </div>
  );
}
